import React from 'react'

export const convertFirmwareName = (firmwareName) => {
  const nameComponents = firmwareName.split('_')

  const productType = nameComponents[0].slice(0, -1) === '01' ? 'Mezzo' : 'Ness Bridge'
  const softwareVersion = `v${+nameComponents[1].split('.').join('')}`
  const cellType = {
    '00': 'NOCELLULAR',
    '01': 'SIM5216_3G',
    '02': 'TELIT_4G',
    '03': 'TELIT_NA',
    '04': 'MA510_GL',
    '05': 'ME910G1_WW',
  }[nameComponents[2]]
  const voiceType = {
    '00': 'N/A',
    '01': 'AU English',
    '02': 'US English',
  }[nameComponents[3]]
  const voiceRevision = `(v${nameComponents[4]})`
  const hardwareRevision = `Hardware Revision: ${nameComponents[5] === '00' ? 'N/A/Proto' : `v${nameComponents[4]}`}`
  const bootloaderVersion = {
    '00': 'N/A',
    C9: 'Mezzo Non-Encrypted original version',
    D9: 'Mezzo Encrypted version',
    E9: 'Mezzo Modern same as 0xD9 plus USB FW update',
    F9: 'Mezzo Modern same as 0xE9 plus remote (cloud) update function',
    FA: 'Ness Bridge, has the same protocol as 0xF9 but no support for remote updates',
  }[nameComponents[6].split('.')[0]]

  return (
    <div style={{ whiteSpace: 'pre-line' }}>
      {/* eslint-disable-next-line max-len */}
      {`${productType} ${softwareVersion} ${cellType} ${voiceType}${voiceRevision} ${hardwareRevision}\n${bootloaderVersion}.`}
    </div>
  )
}
